import React, { useEffect, useState } from "react";
import style from "./sidebar.module.scss";
import { withRouter } from "react-router";
import toPersianNumber from "../../helpers/actions/toPersianNumber"
// import { AuthContext } from "./../auth";
import Modal from "../Modal/Modal"
import { routePermissions } from "../../helpers/consts/routePermissions";
import channel from "../../assets/icons/accessDenied/forbidden-panel.svg"
import packages from "../../assets/icons/accessDenied/forbidden-price.svg"
import pricing from "../../assets/icons/accessDenied/forbidden-pricing.svg"
import product from "../../assets/icons/accessDenied/forbidden-product.svg"
import reports from "../../assets/icons/accessDenied/forbidden-reports.svg"
import variant from "../../assets/icons/accessDenied/forbidden-variety.svg"
import users from "../../assets/icons/accessDenied/forbidden-users.svg"
import Button from "../../Components/Button/button"
import auth from "../../auth";

const matchIcon = [
    { path: "^/users$", icon: users, title: "لیست کاریران" },
    { path: "^/users/permission$", icon: users, title: "لیست کاریران" },
    { path: "^/variants$", icon: variant, title: "تنوع کالاهای ثبت شده" },
    { path: "^/products$", icon: product, title: "کالاهای ثبت شده" },
    { path: "^/channels$", icon: channel, title: "پنل دیجی کالا" },
    { path: "^/pricing$", icon: pricing, title: "قیمت‌گذاری کالاها" },
    { path: "^/report/reportlist$", icon: reports, title: "گزارشات" },
    { path: "^/pricingpackageconfirm/*$", icon: packages, title: "خرید و تمدید بسته" },
    { path: "^/report/create$", icon: reports, title: "گزارشات" },
]

const icons = ["dashboardIcon", "pannelIcon", "variantIcon", "pricingIcon", "reportIcon", "usersIcon", "walletIcon", "settingIcon", "tutorialIcon"]
const items = [
    { title: "داشبورد", styleClassName: 'dashboardIcon', path: "/" },
    {
        title: "قیمت‌گذاری", styleClassName: "pricingIcon", subItems: [
            { title: "پنل‌های فروش", path: "/channels" },
            { title: "تنوع‌ها", path: "/variants" },
            { title: 'وضعیت باکس', path: "/pricing" },
        ]
    },
    {
        title: 'گزارشات', styleClassName: "reportIcon", subItems: [
            { title: 'ساخت گزارش دلخواه', path: "/report/create" },
            { title: 'تمام گزارشات', path: "/report/reportlist" },
            { title: 'پرفروش ‌ترین تنوع‌ها', path: '/report/proreportshow/sellAsc?previewBy=table', state: { _id: "999999999999999999999999", name: "پرفروش ‌ترین تنوع‌ها", englishName: "sellAsc", type: "sell", orderedBy: "asc", description: "لیست پرفروش‌ترین محصولات برای مدیریت بهتر", hint: "" } },
            { title: 'کم‌‌فروش‌ترین تنوع‌ها', path: '/report/proreportshow/sellDsc?previewBy=table', state: { _id: "999999999999999999999998", name: "کم فروش‌ترین تنوع‌ها", englishName: "sellDsc", type: "sell", orderedBy: "dsc", description: "لیست کم فروش‌ترین محصولات برای مدیریت بهتر", hint: "", } },
            { title: 'پرسود ترین تنوع‌ها', path: '/report/proreportshow/prfitAsc?previewBy=table', state: { _id: "659a8d59e135caadb3584957", name: "پرسود ترین تنوع‌ها", englishName: "prfitAsc", type: "profit", orderedBy: "asc", description: "لیست پرسود ترین محصولات برای مدیریت بهتر", hint: "", } },
        ]
    },
    {
        title: 'سفارشات و محموله', styleClassName: 'cargoIcon', subItems: [
            { title: 'سفارشات فعال', path: `/orders` },
            { title: 'محموله', path: "/cargo" },
        ]
    },
    {
        title: 'تنظیمات', styleClassName: 'settingIcon', subItems: [
            { title: 'بازه زمانی', path: "/setting" },
            { title: 'قیمت‌گذاری', path: '/defaultSetting' },
            { title: 'کاربران', path: "/users" },
            { title: 'سطح دسترسی', path: "/users/permission" },
        ]
    },
    { title: 'کنترل موجودی', styleClassName: 'zitronIcon', path: `https://www.zitron.ir?utm_source=mobisha&utm_medium=app&utm_campaign=affiliate&` },
    { title: 'کیف پول', styleClassName: 'walletIcon', path: "/wallet" },
    {
        title: 'پشتیبانی و آموزش', styleClassName: "supportIcon", subItems: [
            { title: 'ویدئوهای آموزشی', path: "/guide" },
            { title: 'پشتیبانی', path: '/support' },
            { title: 'انجمن', path: '/forum' },
        ]
    },
    { title: 'بلک فرایدی', styleClassName: 'blackFriday', path: `/blackfriday/landing` },
]

const Sidebar = (props) => {
    useEffect(() => {
        let temp = openCollapse;
        items.map((item) => {
            if (item.subItems) {
                item.subItems.map((subItem) => {
                    subItem.path === window.location.pathname ? temp.push(item.title) : console.log();
                })
            }
        })
        setOpenCollapse([...temp])
        handleResize()
    }, [])

    useEffect(() => {
        window.addEventListener("resize", handleResize, false);
        if ((sessionStorage.getItem("sideBarOpen") && sessionStorage.getItem("sideBarOpen") == 'false') || (window.innerWidth && window.innerWidth < 769)) {
            setOpen(false)
        } else {
            setOpen(true)
        }
    }, []);

    const handleResize = () => {
        if ((sessionStorage.getItem("sideBarOpen") && sessionStorage.getItem("sideBarOpen") == 'false')) {
            // Do Nothing
        } else {
            if (window.innerWidth && window.innerWidth < 769) {
                setOpen(false)
            } else {
                setOpen(true)
            }
        }
    }

    // const [state, dispatch] = React.useContext(AuthContext)
    const [modal, setModal] = useState({ open: false, path: "" })
    const [open, setOpen] = useState((sessionStorage.getItem("sideBarOpen") && sessionStorage.getItem("sideBarOpen") == 'false') ? false : true)
    const [openCollapse, setOpenCollapse] = useState([])
    const setCollapse = (item) => {
        let index = openCollapse.findIndex(i => i === item.title)
        if (index >= 0) {
            let temp = openCollapse;
            temp.splice(index, 1)
            setOpenCollapse([...temp])
        } else {
            let temp = openCollapse;
            temp.push(item.title)
            setOpenCollapse([...temp])
        }
    }
    const accessCheck = (element) => {
        if (typeof props.user !== "undefined") {
            if (typeof element.path !== "undefined") {
                let permission = routePermissions.find((item) => element.path.match(new RegExp(item.path)))
                if (typeof permission !== "undefined") {
                    let userPermission = Object.keys(props.user.permission).find(item => item === permission.permissionName)
                    if (typeof userPermission != 'undefined' && props.user.permission[userPermission].includes(permission.requiredPermission)) {
                        return true
                    } else return false
                } else return true
            } else return true
        }


    }
    const findIcon = () => {
        if (modal.open && typeof modal.path !== "undefined" && modal.path.length > 0) {
            let icon = matchIcon.find((item) => modal.path.match(new RegExp(item.path)))
            if (typeof icon !== "undefined") {
                return icon.icon
            } else return ""
        }
    }

    return (
        <React.Fragment>
            <div className={style.modalWrapper}>

                <Modal
                    tag='Modal'
                    title='عدم دسترسی'
                    value={modal.open}
                    parentClose={() => {
                        setModal({ open: false, path: "" })
                    }}
                >
                    <div className={style.container}>

                        <img src={findIcon()} alt="" className={style.image} />
                        <p className={style.boldText}>کاربر عزیز، شما اجازه دسترسی به صفحه مورد نظر را ندارید.</p>
                        <p className={style.text}>برای دسترسی به این صفحه، با مدیر بخش خود صحبت کنید.</p>
                    </div>
                    <div className={style.buttonWrapper}>
                        <Button type="solid" label="تایید" onclick={() => setModal({ open: false, path: "" })} />
                        <Button type="outline" label="نمایش داشبورد" onclick={() => props.history.push("/")} />

                    </div>
                </Modal>
            </div>
            <div className={style.pageWithSidebarContainer}>
                <div className={style.container}>
                    <div className={open ? style.closeButton : style.openButton}
                        onClick={(e) => {
                            let tmp = open
                            setOpen(!open)
                            if (!tmp) {
                                sessionStorage.removeItem('sideBarOpen');
                            } else {
                                sessionStorage.setItem("sideBarOpen", false);
                            }
                        }}>
                        <div className={open ? style.open : style.close}></div>
                    </div>
                    <div className={style.sidebarWrapper} style={{ minWidth: open ? "240px" : "92px" }}>
                        {open ?
                            <div className={style.open}>
                                <div className={style.profileBox}>
                                    <div className={style.name}>
                                        {typeof props.user !== "undefined" ? props.user.name : "کاربر"}
                                    </div>
                                    <p>
                                        {typeof props.user !== "undefined" ? toPersianNumber(props.user.phone) : ""}
                                    </p>
                                    <div className={style.editProfile} onClick={() => {
                                        props.history.push("/profile")
                                    }}>ویرایش پروفایل
                                    </div>
                                </div>

                                <div className={style.content}>
                                    {items.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <div
                                                    className={window.location.pathname === item.path ? style.rowActive : style.row}
                                                    onClick={() => setCollapse(item)}>
                                                    <div id='_sideBar_' className={style.right} onClick={() => {
                                                        !item.subItems && (accessCheck(item) ? (!item.path.includes('zitron') ? props.history.push(item.path) : window.location.replace(`${item.path}${props.user.phone}`)) : setModal({
                                                            open: true,
                                                            path: item.path
                                                        }))
                                                    }}>
                                                        <div className={style[item.styleClassName]}>{item.icon}</div>
                                                        <p>{item.title}</p>{item.redTitle && <span className={style.redTitle}>{item.redTitle}</span>}
                                                        {item.subItems && accessCheck(item) == true && <div
                                                            className={openCollapse.findIndex(i => i === item.title) >= 0 ? style.collapseActive : style.collapseInActive}
                                                        >
                                                        </div>
                                                        }
                                                    </div>
                                                    {
                                                        accessCheck(item) ? null :
                                                            <div className={style.left}>
                                                                <div className={style.lockIcon}></div>
                                                            </div>
                                                    }
                                                </div>
                                                <div className={style.subItemWrapper}>
                                                    {
                                                        typeof item.subItems !== "undefined" && openCollapse.findIndex(i => i === item.title) >= 0 ?
                                                            item.subItems.map((element, index) => {
                                                                return (<div
                                                                    key={"sub" + index}
                                                                    className={window.location.pathname === element.path ? style.rowTwoActive : style.rowTwo}
                                                                >
                                                                    <div className={style.right}
                                                                        onClick={() => {
                                                                            accessCheck(element) ?
                                                                                props.history.push({
                                                                                    pathname: element.path,
                                                                                    state: element.state ? { report: { ...element.state } } : {}
                                                                                })
                                                                                :
                                                                                setModal({
                                                                                    open: true,
                                                                                    path: element.path
                                                                                })
                                                                        }}>
                                                                        <p>{element.title}</p>
                                                                    </div>
                                                                    {
                                                                        accessCheck(element) ? null :
                                                                            <div className={style.left}>
                                                                                <div className={style.lockIcon}></div>
                                                                            </div>
                                                                    }
                                                                </div>

                                                                )
                                                            }
                                                            )
                                                            : null
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })}
                                    <div className={style.bottomIcons}>
                                        {/*<div className={style.rowThreeSupport}>
                                            <div className={style.supportNumber}>
                                                شماره پشتیبانی: {toPersianNumber('8705 227 0902')}
                                            </div>
                                     </div>*/}
                                        <div className={style.rowThree} onClick={() => auth.logout()}>
                                            <div className={style.right}>
                                                <div className={style.exitIcon}></div>
                                                <p>خروج</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            :
                            <div className={style.closed}>
                                <div className={style.profileBox}
                                    onClick={() => props.history.push('/profile')}
                                >
                                    <div className={style.tooltip}>
                                        <div className={style.profileIcon}></div>
                                        <span className={style.tooltiptext}><p>ویرایش پروفایل</p></span>
                                    </div>
                                </div>

                                <div className={style.gap}></div>
                                {
                                    items.map((item, index) => {
                                        return <div
                                            className={`${window.location.pathname === item.path ? style.iconWrapActive : style.iconWrap} ${style.tooltip}`}
                                            key={index}
                                            onClick={() => {
                                                !item.subItems && (accessCheck(item) ? (!item.path.includes('zitron') ? props.history.push(item.path) : window.location.replace(`${item.path}${props.user.phone}`)) : setModal({
                                                    open: true,
                                                    path: item.path
                                                }));
                                                if (typeof item.subItems !== "undefined") {
                                                    setCollapse(item)
                                                }
                                            }}
                                        >
                                            <div className={style[item.styleClassName]}></div>
                                            <span className={style.tooltiptext}><p>{item.title}</p></span>

                                            {/* ------------------------------------ sub items --------------------------------------- */}
                                            {
                                                typeof item.subItems !== "undefined" && openCollapse.findIndex(i => i === item.title) >= 0 ?
                                                    <div className={style.hiddenSubItems}>
                                                        <div className={style.flexBox}>
                                                            {item.subItems.map((element, index) => <div
                                                                key={'element' + index}
                                                                className={window.location.pathname === element.path ? style.flexItemActive : style.flexItem}
                                                                onClick={() => {
                                                                    accessCheck(element) ? (props.history.push(element.path)) : setModal({
                                                                        open: true,
                                                                        path: element.path
                                                                    })
                                                                }}

                                                            >
                                                                <div className={style.title}>{element.title}</div>

                                                                {
                                                                    accessCheck(element) ? null :
                                                                        <div className={style.left}>
                                                                            <div className={style.lockIcon}></div>
                                                                        </div>
                                                                }
                                                            </div>)}
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                            {/* ------------------------------------ sub items --------------------------------------- */}
                                        </div>
                                    })
                                }

                                <div
                                    className={`${style.iconWrapExit} ${style.tooltip}`}
                                    onClick={() => auth.logout()}
                                >
                                    <div className={style.exitIcon}></div>
                                    <span className={style.tooltiptext}><p>خروج</p></span>
                                </div>
                            </div>
                        }
                    </div>

                </div>
                <div className={style.pageWrapper}>
                    {props.children}
                </div>
            </div>
        </React.Fragment>
    );
}

export default withRouter(Sidebar);



// { title: "داشبورد", styleClassName: 'dashboardIcon', path: "/" },
// {
//     title: "پنل‌های فروش",
//     styleClassName: "pannelIcon",
//     path: "/channels"
// },
// {
//     title: "تنوع‌ها", styleClassName: "variantIcon",
//     subItems: [
//         {
//             title: "دیجی‌کالا",
//             path: "/variants"
//         },
//         {
//             title: "اسنپ‌شاپ",
//             path: "/snappshopvariants"
//         },
//     ]
// },
// {
//     title: "قیمت‌گذاری",
//     styleClassName: "pricingIcon",
//     subItems: [
//         {
//             title: "دیجی‌کالا",
//             path: "/pricing"
//         },
//         {
//             title: "اسنپ‌شاپ",
//             path: "/snappshop"
//         }
//     ],
// },
// {
//     title: "گزارشات",
//     styleClassName: "reportIcon",
//     subItems: [
//         {
//             title: "همه",
//             path: "/report/reportlist"
//         },
//         {
//             title: "ساخت گزارش",
//             path: "/report/create"
//         },
//         {
//             title: "گزارش پیشرفته",
//             path: "/report/proreportlist"
//         }]
// },
// { title: 'سفارشات', styleClassName: 'ordersIcon', path: `/orders` },
// { title: 'کنترل موجودی', styleClassName: 'zitronIcon', path: `https://www.zitron.ir?utm_source=mobisha&utm_medium=app&utm_campaign=affiliate&` },
// {
//     title: "مدیریت کاربران",
//     styleClassName: "usersIcon",
//     subItems: [
//         {
//             title: "همه",
//             path: "/users"
//         },
//         {
//             title: "سطح دسترسی",
//             path: "/users/permission"
//         }]
// },
// { title: "محموله‌ها", redTitle: 'جدید', styleClassName: 'cargoIcon', path: "/cargo" },
// { title: "کیف پول", styleClassName: 'walletIcon', path: "/wallet" },
// { title: "تنظیمات", styleClassName: 'settingIcon', path: "/setting" },
// // { title: "خرید و تمدید بسته", icon: "x", path: "/userpackages" },
// { title: "ویدیوهای آموزشی", styleClassName: "tutorialIcon", path: "/guide" },
// { title: "پشتیبانی", styleClassName: "supportIcon", path: "/support" },
// // {title: "فعالیت‌های ربات", icon: "F", path: "/log"},